import { InsufficientFundsError } from '../../../errors/InsufficientFundsError';
import type { UTXO } from '../../WaasBitcoinWalletProvider.types';
import { calculateUTXOTotal } from '../calculateUTXOTotal';

type ValidateAndSelectUTXOsOptions = {
  allUTXOs: UTXO[];
  amountInSatoshis: number;
  feeEstimate: number;
  selectedTotal: number;
  selectedUTXOs: UTXO[];
};

/**
 * Validates and ensures sufficient funds for the transaction
 *
 * @param options.allUTXOs - Complete array of available UTXOs for the address
 * @param options.amountInSatoshis - Amount to send in satoshis
 * @param options.feeEstimate - Estimated transaction fee in satoshis
 * @param options.selectedTotal - Total value of initially selected UTXOs in satoshis
 * @param options.selectedUTXOs - Array of initially selected UTXOs
 * @returns Validated selected UTXOs
 * @throws InsufficientFundsError if insufficient funds
 */
export const validateAndSelectUTXOs = (
  options: ValidateAndSelectUTXOsOptions
) => {
  const {
    allUTXOs,
    amountInSatoshis,
    feeEstimate,
    selectedTotal,
    selectedUTXOs,
  } = options;

  const requiredAmount = amountInSatoshis + feeEstimate;

  if (selectedTotal >= requiredAmount) {
    return selectedUTXOs;
  }

  if (selectedUTXOs.length < allUTXOs.length) {
    const allTotal = calculateUTXOTotal(allUTXOs);

    if (allTotal < requiredAmount) {
      throw new InsufficientFundsError({
        availableSatoshis: allTotal,
        requiredSatoshis: amountInSatoshis,
      });
    }

    return allUTXOs;
  }

  throw new InsufficientFundsError({
    availableSatoshis: selectedTotal,
    requiredSatoshis: amountInSatoshis,
  });
};
